export default function CompletedAssessmentDirective() {
  return {
    template: require('./completed-assessment.html'),
    scope: {
      assessment: '=',
      hasActiveAssessments: '=',
      isNavantaUser: '=',
    },
    controller: 'ECATCompletedAssessmentController',
    controllerAs: 'completedAssessmentVM',
    bindToController: true,
    replace: true,
  };
}
